import React from 'react';
import { Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import './styles.less';

const CLASS_NAME = 'modal-action-buttons';

const ModalActionButtons = ({ buttons }) => (
	<div className={CLASS_NAME} data-testid="modal-action-buttons">
		{buttons.map(({ color, onClick, text, disabled, loading, type, isSeparator }) => (
			<div
				className={`${
					type === 'icon' ? 'modal-action-buttons__icon-wrapper' : 'modal-action-buttons__button-wrapper'
				}`}
				key={text}
				data-testid="action-button-wrapper"
			>
				{type === 'close' ? (
					<div className={`${CLASS_NAME}__close-button`} onClick={onClick} />
				) : (
					<Button
						className={color || 'primary'}
						onClick={onClick}
						type="button"
						disabled={disabled}
						loading={loading}
						data-testid="action-button"
					>
						{text}
					</Button>
				)}
				{isSeparator && <div className={`${CLASS_NAME}__separator`} data-testid="modal-action-separator" />}
			</div>
		))}
	</div>
);

ModalActionButtons.propTypes = {
	buttons: PropTypes.arrayOf(
		PropTypes.shape({
			color: PropTypes.string,
			onClick: PropTypes.func,
			text: PropTypes.string,
			disabled: PropTypes.bool,
			type: PropTypes.string,
			isSeparator: PropTypes.bool,
		}),
	),
};

export { ModalActionButtons };
